import { Skeleton } from '@/shared/components';

const AssetRow = () => (
  <div className="flex flex-col gap-[1.2rem]">
    <div className="flex h-[2.4rem] items-center justify-between gap-[1.6rem]">
      <Skeleton variant="small" className="w-[7.2rem] bg-stroke" />
      <div className="flex items-center gap-[0.8rem]">
        <Skeleton className="h-[2.4rem] w-[6.4rem] rounded-[0.8rem] bg-stroke" />
        <Skeleton className="h-[2.4rem] w-[6.4rem] rounded-[0.8rem] bg-stroke" />
        <Skeleton className="h-[2.4rem] w-[6.4rem] rounded-[0.8rem] bg-stroke" />
      </div>
    </div>
    <div className="flex h-[6.8rem] items-center justify-between rounded-[1.6rem] ps-[2.4rem] pe-[2.4rem] ring-1 ring-inset ring-stroke">
      <Skeleton variant="large" className="w-[6rem] bg-stroke" />
      <Skeleton variant="small" className="w-[6.4rem] bg-stroke" />
    </div>
  </div>
);

const ExchangeSectionSkeleton = () => {
  return (
    <div className="flex flex-col gap-[2.4rem]">
      <div className="flex flex-col gap-[2.4rem] tablet:gap-[3.6rem]">
        <AssetRow />
        <AssetRow />
      </div>

      <div className="grid grid-cols-[1fr_auto] tablet:grid-cols-2 items-end gap-[0.6rem] p-[0.8rem]">
        <div className="flex flex-col gap-[0.8rem]">
          <Skeleton variant="small" className="w-[5.4rem] bg-stroke" />
          <Skeleton variant="medium" className="w-[7.2rem] bg-stroke" />
        </div>
        <Skeleton className="w-[13.6rem] tablet:w-full tablet:max-w-[22.6rem] tablet:justify-self-end h-[4.4rem] rounded-[1.2rem] bg-stroke" />
      </div>
    </div>
  );
};

export { ExchangeSectionSkeleton };
